import API from '../../../../../services/api';

export const BASTIDORES_API = {
    get: async(data) => {
        return API.post('bastidores/get-all-bastidores', data).then(res => res.data);
    },
    getByMatricula: async (data) => {
        return API.post('bastidores/get-bastidor', data).then(res => res.data);
    },
    getMoreInfoVehicle: async (ktype) => {
        return API.get(`bastidores/${ktype}/more-info`).then(res => res.data);
    }
}
